<template>
    <div>
        <div class="md-layout md-alignment-center-right" v-if="fabShow">
            <div class="md-layout-item md-size-30">
                <md-field md-clearable>
                    <label>序列号</label>
                    <md-input v-model="searchDeviceSn" placeholder="输入序列号搜索"></md-input>
                </md-field>
            </div>
            <div class="md-layout-item md-size-10" id="device_search">
                <md-button class="md-raised md-primary" @click="searchDevice">搜索设备</md-button>
            </div>
        </div>

        <div class="md-layout md-alignment-center-right">
            <div class="md-layout-item md-size-30">
                <md-field md-clearable md-inline>
                    <label>输入公司名称按回车键搜索</label>
                    <md-input v-model="filterCompanyName" @keyup.enter="search(filterCompanyName)"></md-input>
                </md-field>
            </div>
        </div>

        <div class="md-layout md-alignment-center-right">
            <div class="md-layout-item md-size-30">
                <md-field md-clearable md-inline>
                    <label>输入设备名称按回车键搜索</label>
                    <md-input v-model="filterDeviceName" @keyup.enter="searchByDeviceName(filterDeviceName)"></md-input>
                </md-field>
            </div>
        </div>
      <div class="md-layout md-alignment-center-left">
        <div class="md-layout-item md-size-30">
          <md-button class="md-raised md-primary" @click="changeGlobalAdv">{{ globalAdvShow ? '全局广告已开启' : '全局广告已关闭' }}
          </md-button>
        </div>
      </div>
        <md-table>
            <md-table-row>
                <md-table-head class="table_head">公司ID</md-table-head>
                <md-table-head class="table_head">公司名称</md-table-head>
                <md-table-head class="table_head">管理员账号</md-table-head>
                <md-table-head class="table_head">联系人</md-table-head>
                <md-table-head class="table_head">联系电话</md-table-head>
                <md-table-head class="table_head">授权设备数</md-table-head>
                <md-table-head class="table_head">操作</md-table-head>
            </md-table-row>

            <md-table-row
                    v-for="(item, index) in filterCompanies"
                    v-bind:key="item.id">
                <md-table-cell>{{ item.id }}</md-table-cell>
                <md-table-cell>{{ item.name }}</md-table-cell>
                <md-table-cell>{{ item.user.account }}</md-table-cell>
                <md-table-cell>{{ item.contact_name }}</md-table-cell>
                <md-table-cell>{{ item.contact_phone }}</md-table-cell>
                <md-table-cell>{{ item.auth_number }}</md-table-cell>
                <md-table-cell>
                  <md-button class="md-accent" @click="changeCompanyAdv(item.id, item.allow_adv_show)">
                    {{ item.allow_adv_show ? '广告已开启' : '广告已关闭' }}
                  </md-button>
                </md-table-cell>

                <md-table-cell>
                    <md-button class="md-primary" @click="authManager(item.id)">管理</md-button>
                    <md-button class="md-primary" @click="showImportSnDialog(item.id)">导入</md-button>
                    <md-menu md-direction="bottom-end" :mdCloseOnClick="true">
                        <md-button md-menu-trigger class="md-icon-button">
                            <md-icon>more_vert</md-icon>
                        </md-button>

                        <md-menu-content>
                            <md-menu-item @click="showModifyCompanyAccountDialog(index)">修改管理员账号</md-menu-item>
                            <md-menu-item @click="showModifyCompanyDialog(index)">修改信息</md-menu-item>
                            <md-menu-item @click="setupCompany(index)">唤醒设置</md-menu-item>
                        </md-menu-content>
                    </md-menu>
                </md-table-cell>
            </md-table-row>

        </md-table>

      <div class="md-layout md-alignment-center-right">
        <md-button @click="gotoPageAt(page - 1)">上一页</md-button>
        <md-button @click="gotoPageAt(parseInt(page) + 1)">下一页</md-button>
        总计{{Math.floor(total / count) + (total % count === 0 ? 0 : 1)}}页，当前第{{page}}页

        <div class="md-layout-item md-size-15">
          <md-field>
            <label for="count">每页显示条数</label>
            <md-select v-model="count" name="count" id="count" @md-selected="companyList">
              <md-option value="15">每页显示15条</md-option>
              <md-option value="30">每页显示30条</md-option>
              <md-option value="60">每页显示60条</md-option>
              <md-option value="100">每页显示100条</md-option>
              <md-option value="200">每页显示200条</md-option>
            </md-select>
          </md-field>
        </div>

        <div class="md-layout-item md-size-10" id="page_input">
          <md-field md-inline md-clearable>
            <label>输入页数</label>
            <md-input v-model="goPage" type="number"></md-input>
          </md-field>
        </div>
        <div class="md-layout-item md-size-10" id="device_page">
          <md-button class="md-accent md-raised md-dense" @click="gotoPage">跳转</md-button>
        </div>
      </div>

      <md-button class="md-fab" @click="addNewCompanyDialog = true" v-if="fabShow">
            <md-icon>add</md-icon>
        </md-button>

        <md-dialog :md-active.sync="snImportDialog">
            <md-dialog-title>EXCEL批量导入设备</md-dialog-title>
            <div class="md-layout">
                <md-field>
                    <label>请选择EXCEL文件</label>
                    <md-file accept="application/xls" name="excel_sns" @change="inputFileChange"/>
                </md-field>
            </div>
            <md-dialog-actions>
                <md-button class="md-primary" @click="snImportDialog = false">取消</md-button>
                <md-button class="md-primary" @click="importSn">导入</md-button>
            </md-dialog-actions>
        </md-dialog>

        <md-dialog :md-active.sync="addNewCompanyDialog">
            <md-dialog-title>新建公司</md-dialog-title>
            <div class="md-layout">
                <div class="md-layout-item">
                    <md-field>
                        <label>公司名称*</label>
                        <md-input v-model="newCompany.name"></md-input>
                    </md-field>
                </div>
            </div>
            <div class="md-layout">
                <div class="md-layout-item md-size-33">
                    <md-field>
                        <label>管理员账号*</label>
                        <md-input v-model="newCompany.admin_account"></md-input>
                    </md-field>
                </div>
            </div>
            <div class="md-layout">
                <div class="md-layout-item">
                    <md-field>
                        <label>联系人</label>
                        <md-input v-model="newCompany.contact_name"></md-input>
                    </md-field>
                </div>
                <div class="md-layout-item">
                    <md-field>
                        <label>联系电话</label>
                        <md-input v-model="newCompany.contact_phone"></md-input>
                    </md-field>
                </div>
                <div class="md-layout-item">
                    <md-field>
                        <label>微信号</label>
                        <md-input v-model="newCompany.contact_weichat"></md-input>
                    </md-field>
                </div>
            </div>
            <div class="md-layout">
                <div class="md-layout-item">
                    <md-field>
                        <label>地址</label>
                        <md-input v-model="newCompany.address"></md-input>
                    </md-field>
                </div>
            </div>
            <div class="md-layout">
                <div class="md-layout-item">
                    <md-field>
                        <label>备注</label>
                        <md-input v-model="newCompany.remarks"></md-input>
                    </md-field>
                </div>
            </div>
            <md-dialog-actions>
                <md-button class="md-primary" @click="addNewCompanyDialog = false">取消</md-button>
                <md-button class="md-primary" @click="createCompany">新增</md-button>
            </md-dialog-actions>
        </md-dialog>

        <md-dialog :md-active.sync="modifyCompanyAccountDialog">
            <md-dialog-title>修改管理员账号</md-dialog-title>
            <div class="md-layout">
                <div class="md-layout-item">
                    <md-field>
                        <label>请输入新的账号</label>
                        <md-input v-model="newAccount"></md-input>
                    </md-field>
                </div>
            </div>
            <md-dialog-actions>
                <md-button class="md-primary" @click="modifyCompanyAccountDialog = false">取消</md-button>
                <md-button class="md-primary" @click="modifyCompanyAccount">确定</md-button>
            </md-dialog-actions>
        </md-dialog>

        <md-dialog :md-active.sync="modifyCompanyDialog">
            <md-dialog-title>修改公司</md-dialog-title>
            <div class="md-layout">
                <div class="md-layout-item">
                    <md-field>
                        <label>公司名称</label>
                        <md-input v-model="companyModify.name"></md-input>
                    </md-field>
                </div>
            </div>
            <div class="md-layout">
                <div class="md-layout-item">
                    <md-field>
                        <label>联系人</label>
                        <md-input v-model="companyModify.contact_name"></md-input>
                    </md-field>
                </div>
                <div class="md-layout-item">
                    <md-field>
                        <label>联系电话</label>
                        <md-input v-model="companyModify.contact_phone"></md-input>
                    </md-field>
                </div>
                <div class="md-layout-item">
                    <md-field>
                        <label>微信号</label>
                        <md-input v-model="companyModify.contact_weichat"></md-input>
                    </md-field>
                </div>
            </div>
            <div class="md-layout">
                <div class="md-layout-item">
                    <md-field>
                        <label>地址</label>
                        <md-input v-model="companyModify.address"></md-input>
                    </md-field>
                </div>
            </div>
            <div class="md-layout">
                <div class="md-layout-item">
                    <md-field>
                        <label>备注</label>
                        <md-input v-model="companyModify.remarks"></md-input>
                    </md-field>
                </div>
            </div>
            <md-dialog-actions>
                <md-button class="md-primary" @click="modifyCompanyDialog = false">取消</md-button>
                <md-button class="md-primary" @click="modifyCompany">修改</md-button>
            </md-dialog-actions>
        </md-dialog>

        <md-dialog :md-active.sync="loading">
            <div class="md-layout">
                <div class="md-layout-item">
                    <md-field>
                        <div>{{importResultTips}}</div>
                    </md-field>
                </div>
            </div>
            <div class="md-layout" v-if="importResult">
                <div class="md-layout-item">
                    <md-field>
                        <div>{{importResult}}</div>
                    </md-field>
                </div>
            </div>
        </md-dialog>

        <md-dialog :md-active.sync="showSearchResultDialog">
            <md-table v-model="filterDevices" md-card>
                <md-table-toolbar>
                    <h1 class="md-title">搜索结果</h1>
                </md-table-toolbar>

                <md-table-row slot="md-table-row" slot-scope="{ item }">
                    <md-table-cell md-label="id" md-numeric>{{ item.id }}</md-table-cell>
                    <md-table-cell md-label="设备名称">{{ item.device_name }}</md-table-cell>
                    <md-table-cell md-label="设备序列号">{{ item.serial_number }}</md-table-cell>
                    <md-table-cell md-label="所属公司">{{ item.company.name }}</md-table-cell>
                    <md-table-cell md-label="状态">{{ item.freeze?'已冻结':'正常' }}</md-table-cell>
                </md-table-row>
            </md-table>
        </md-dialog>
        <md-snackbar :md-active.sync="toast">{{ toastMsg }}</md-snackbar>
    </div>
</template>

<script>
    export default {
        name: "Companies",
        data: () => ({
            companies: [],
            filterCompanies: [],
            newCompany: {freeze: false},
            companyModify: {freeze: false},
            addNewCompanyDialog: false,
            modifyCompanyDialog: false,
            modifyCompanyAccountDialog: false,
            newAccountCompanyId: 0,
            newAccount: '',
            toast: false,
            toastMsg: "",
            fabShow: false,
            snImportCompanyId: 0,
            snImportDialog: false,
            snImportFile: null,
            loading: false,
            importResult: null,
            importResultTips: '加载中...',
            searchDeviceSn: '',
            filterDevices: [],
            showSearchResultDialog: false,
            filterCompanyName: '',
            filterDeviceName: '',
            globalAdvShow: false,
            page: 1,
            goPage: '',
            total: 0,
            count: 15,
        }),
        mounted() {
            let userInfo = JSON.parse(localStorage.getItem('user_info'));
            this.fabShow = userInfo.role === 1;
            this.companyList();
            this.queryGlobalAdv();
        },
        methods: {
          gotoPage: function () {
            if (this.goPage) {
              this.page = this.goPage;
              this.companyList();
            } else {
              this.showErrorTips('请输入页数');
            }
          },
          gotoPageAt: function (p) {
            if (p <= 0) p = 1;
            this.page = p;
            this.companyList();
          },
            companyList: function () {
                this.$http.get('/api/company/?page=' + this.page + "&count=" + this.count).then(
                    response => {
                        if (response.status === 200) {
                            let data = response.data;
                            if (data.code === 0) {
                              this.total = data.data.total;
                              this.companies = data.data.companies;
                                this.filterCompanies = this.companies.slice()
                            } else {
                                switch (data.code) {
                                    case 3000:
                                        this.showErrorTips('当前账号没有权限（3000）');
                                        break;
                                    default:
                                        this.showErrorTips('获取公司列表失败，服务器返回错误码' + data.code);
                                        break
                                }
                            }
                        } else {
                            this.showErrorTips('请求失败，HTTP错误码' + response.status);
                        }
                    }
                ).catch(error => {
                    if (error.response.status === 403) {
                        localStorage.clear();
                        this.$router.replace('/login')
                    } else {
                        this.showErrorTips('未知错误' + error);
                    }
                })
            },
            search:function (name){
              if (name) {
                this.searchName(name);
              } else {
                this.companyList();
              }
            },
            searchByDeviceName:function (name){
              if (name) {
                this.$http.get('/api/device/company/' + name + "/").then(
                    response => {
                      if (response.status === 200) {
                        let data = response.data;
                        if (data.code === 0) {
                          this.total = data.data.total;
                          this.companies = data.data.companies;
                          this.filterCompanies = this.companies.slice()
                        } else {
                          switch (data.code) {
                            case 3000:
                              this.showErrorTips('当前账号没有权限（3000）');
                              break;
                            default:
                              this.showErrorTips('搜索公司失败，服务器返回错误码' + data.code);
                              break
                          }
                        }
                      } else {
                        this.showErrorTips('请求失败，HTTP错误码' + response.status);
                      }
                    }
                ).catch(error => {
                  if (error.response.status === 403) {
                    localStorage.clear();
                    this.$router.replace('/login')
                  } else {
                    this.showErrorTips('未知错误' + error);
                  }
                })
              } else {
                this.companyList();
              }
            },
            searchName: function (name) {
                this.$http.get('/api/company/search/name/' + name + "/").then(
                    response => {
                        if (response.status === 200) {
                            let data = response.data;
                            if (data.code === 0) {
                              this.total = data.data.total;
                              this.companies = data.data.companies;
                                this.filterCompanies = this.companies.slice()
                            } else {
                                switch (data.code) {
                                    case 3000:
                                        this.showErrorTips('当前账号没有权限（3000）');
                                        break;
                                    default:
                                        this.showErrorTips('搜索公司失败，服务器返回错误码' + data.code);
                                        break
                                }
                            }
                        } else {
                            this.showErrorTips('请求失败，HTTP错误码' + response.status);
                        }
                    }
                ).catch(error => {
                    if (error.response.status === 403) {
                        localStorage.clear();
                        this.$router.replace('/login')
                    } else {
                        this.showErrorTips('未知错误' + error);
                    }
                })
            },
            createCompany: function () {
                if (!this.newCompany.name) {
                    this.showErrorTips('必须输入公司名称');
                    return;
                }
                if (!this.newCompany.admin_account) {
                    this.showErrorTips('管理员账号');
                    return;
                }
                this.addNewCompanyDialog = false
                this.$http.post('/api/company/', this.newCompany).then(response => {
                    if (response.status === 200) {
                        let data = response.data;
                        if (data.code === 0) {
                            this.newCompany = {freeze: false};
                            this.companyList();
                        } else {
                            switch (data.code) {
                                case 3000:
                                    this.showErrorTips('当前账号没有权限（3000）');
                                    break;
                                default:
                                    this.showErrorTips('创建新公司失败，服务器返回错误码' + data.code);
                                    break
                            }
                        }
                    } else {
                        this.showErrorTips('创建失败，HTTP错误码' + response.status);
                    }
                }).catch(error => {
                    this.showErrorTips('未知错误' + error);
                })
            },
            modifyCompanyAccount: function () {
                this.modifyCompanyAccountDialog = false;
                this.$http.put('/api/company/' + this.newAccountCompanyId + "/admin/" + this.newAccount + "/").then(response => {
                    if (response.status === 200) {
                        let data = response.data;
                        if (data.code === 0) {
                            this.showTips('修改成功');
                            this.newAccountCompanyId = 0;
                            this.newAccount = '';
                            this.companyList();
                        } else {
                            switch (data.code) {
                                case 1200:
                                    this.showErrorTips('账号已存在（1200）');
                                    break;
                                case 3000:
                                    this.showErrorTips('当前账号没有权限（3000）');
                                    break;
                                default:
                                    this.showErrorTips('修改公司失败，服务器返回错误码' + data.code);
                                    break
                            }
                        }
                    } else {
                        this.showErrorTips('修改失败，HTTP错误码' + response.status);
                    }
                }).catch(error => {
                    this.showErrorTips('未知错误' + error);
                })
            },
            modifyCompany: function () {
                this.modifyCompanyDialog = false
                this.$http.put('/api/company/' + this.companyModify.id + "/", this.companyModify).then(response => {
                    if (response.status === 200) {
                        let data = response.data;
                        if (data.code === 0) {
                            this.showTips('修改成功');
                            this.companyModify = {freeze: false};
                            this.companyList();
                        } else {
                            switch (data.code) {
                                case 3000:
                                    this.showErrorTips('当前账号没有权限（3000）');
                                    break;
                                default:
                                    this.showErrorTips('修改公司失败，服务器返回错误码' + data.code);
                                    break
                            }
                        }
                    } else {
                        this.showErrorTips('修改失败，HTTP错误码' + response.status);
                    }
                }).catch(error => {
                    this.showErrorTips('未知错误' + error);
                })
            },
            showModifyCompanyAccountDialog: function (index) {
                this.modifyCompanyAccountDialog = true;
                this.newAccountCompanyId = this.filterCompanies[index].id;
            },
            showModifyCompanyDialog: function (index) {
                let company = this.filterCompanies[index];
                this.companyModify.id = company.id;
                this.companyModify.name = company.name;
                this.companyModify.contact_name = company.contact_name;
                this.companyModify.contact_phone = company.contact_phone;
                this.companyModify.contact_weichat = company.contact_weichat;
                this.companyModify.address = company.address;
                this.companyModify.remarks = company.remarks;
                this.companyModify.freeze = company.freeze;
                this.modifyCompanyDialog = true;
            },
            setupCompany: function(index) {
                let company = this.filterCompanies[index];
                this.$router.push('/dashboard/company-settings/' + company.id)
            },
            showImportSnDialog: function (companyId) {
                this.snImportDialog = true;
                this.snImportCompanyId = companyId;
            },
            inputFileChange(e) {
                this.snImportFile = e.target.files[0]
            },
            importSn: function () {
                this.snImportDialog = false;
                this.importResultTips = "加载中...";
                this.importResult = null;
                this.loading = true;
                let postData = new FormData();
                postData.append('devices', this.snImportFile);
                this.$http.post('/api/device/' + this.snImportCompanyId + '/batch/', postData)
                    .then(response => {
                        if (response.status === 200) {
                            let data = response.data;
                            if (data.code === 0) {
                                this.showTips('导入成功');
                                if (data.data.sns.length === 0) {
                                    this.importResultTips = "导入成功";
                                    this.importResult = null;
                                } else {
                                    this.importResultTips = "如下sn导入失败";
                                    this.importResult = data.data.sns.toString();
                                }
                            } else {
                                this.loading = false;
                                switch (data.code) {
                                    case 3000:
                                        this.showErrorTips('当前账号没有权限（3000）');
                                        break;
                                    case 8000:
                                        this.showErrorTips('无更多可用授权数（8000）');
                                        break;
                                    case 10000:
                                        this.showErrorTips('导入失败（10000）');
                                        break;
                                    default:
                                        this.showErrorTips('导入失败，服务器返回错误码' + data.code);
                                        break
                                }
                            }
                        }
                    })
                    .catch(error => {
                        this.loading = false;
                        this.showErrorTips('未知错误' + error);
                    });
            },
            authManager(id) {
                this.$router.push('/dashboard/auth-manager/' + id)
            },
            searchDevice: function () {
                this.$http.get('/api/device/search/' + this.searchDeviceSn + '/').then(
                    response => {
                        if (response.status === 200) {
                            let data = response.data;
                            if (data.code === 0) {
                                this.filterDevices = data.data.devices;
                                this.showSearchResultDialog = true;
                            } else {
                                this.showErrorTips('请求失败，服务器返回错误码' + data.code);
                            }
                        } else {
                            this.showErrorTips('请求失败，HTTP错误码' + response.status);
                        }
                    }
                ).catch(error => {
                    this.showErrorTips('未知错误' + error);
                })
            },
            changeCompanyAdv: function (id, advShow) {
              this.$http.put('/api/company/' + id + "/adv/" + !advShow).then(response => {
                if (response.status === 200) {
                  let data = response.data;
                  if (data.code === 0) {
                    this.companyList();
                  } else {
                    this.showErrorTips('修改失败，服务器返回错误码' + data.code);
                  }
                } else {
                  this.showErrorTips('修改失败，HTTP错误码' + response.status);
                }
              }).catch(error => {
                this.showErrorTips('未知错误' + error);
              })
            },
            queryGlobalAdv: function () {
              this.$http.get('/api/app/adv/').then(response => {
                if (response.status === 200) {
                  let data = response.data;
                  if (data.code === 0) {
                    this.globalAdvShow = data.data.show;
                  } else {
                    this.showErrorTips('修改失败，服务器返回错误码' + data.code);
                  }
                } else {
                  this.showErrorTips('修改失败，HTTP错误码' + response.status);
                }
              }).catch(error => {
                this.showErrorTips('未知错误' + error);
              })
            },
            changeGlobalAdv: function () {
              let advShow = this.globalAdvShow;
              this.$http.post('/api/app/adv/' + !advShow + '/').then(response => {
                if (response.status === 200) {
                  let data = response.data;
                  if (data.code === 0) {
                    this.globalAdvShow = !advShow;
                  } else {
                    this.showErrorTips('修改失败，服务器返回错误码' + data.code);
                  }
                } else {
                  this.showErrorTips('修改失败，HTTP错误码' + response.status);
                }
              }).catch(error => {
                this.showErrorTips('未知错误' + error);
              })
            },
            showTips: function (message) {
                this.toast = true
                this.toastMsg = message
            },
            showErrorTips: function (message) {
                this.toast = true
                this.toastMsg = message
            },
        }
    }
</script>

<style scoped>
    .table_head {
        text-align: center;
    }

    .md-fab {
        display: block;
        bottom: 0;
        right: 16px;
        position: fixed;
    }

    .md-layout-item {
        padding: 0 20px;
    }
</style>